import {initElements, playVideo} from '../define/shared'

export default function initMapSVGBlocks() {
    initElements('.wab.wab-map-svg', initMapSVGBlock)
}

/**
 * @param {HTMLElement} root
 */
export function initMapSVGBlock(root) {
    const buildings = root.querySelectorAll('.building'),
        green = root.querySelector('.building.is--green'),
        yellow = root.querySelector('.building.is--yellow')

    initElements({root, selector: '.building'}, building => {

        window.addEventListener('resize', onClick)
        window.addEventListener('load', onClick)

        function onClick() {
            building.core = building
            if (window.matchMedia("(max-width: 1024px)").matches) {
                building.addEventListener('click', makeActive)
                building.removeEventListener('mouseover', onHover)
                building.removeEventListener('mouseleave', onHoverEnd)
            } else {
                building.removeEventListener('click', makeActive)
                building.addEventListener('mouseover', onHover)
                building.addEventListener('mouseleave', onHoverEnd)
                buildings.forEach(item => {
                    item.classList.remove('is--active')
                })
            }
        }

        function onHover() {
            // if (!building.classList.contains('is--green')) {
            //     green.classList.add('is--inactive')
            // }
            //
            // if (!building.classList.contains('is--yellow')) {
            //     yellow.classList.add('is--inactive')
            // }

            displayContent(building)
        }

        function onHoverEnd() {
            // green.classList.remove('is--inactive')
            // yellow.classList.remove('is--inactive')
            root.querySelectorAll('.descrription').forEach(el => el.style.display = 'none')
            root.querySelector('[data-content="b-0"]').style.display = 'block'
        }

    })

    function makeActive(event) {
        event.preventDefault()
        const building = event.currentTarget.core

        buildings.forEach(item => {
            item.classList.remove('is--active')
        })

        building.classList.add('is--active')
        !building.classList.contains('is--green')
            ? green.classList.add('is--inactive')
            : green.classList.remove('is--inactive')
        !building.classList.contains('is--yellow')
            ? yellow.classList.add('is--inactive')
            : yellow.classList.remove('is--inactive')

        displayContent(building)
    }

    function displayContent(building) {
        initElements({root, selector: '.descrription'}, descrription => {
            descrription.style.display = 'none'

            if (descrription.dataset.content === building.id) {
                descrription.style.display = 'block'
            }
        })
    }
}
